import moment from "moment";

export const useReminderStatus = (reminderDate) => {
  const date = moment(reminderDate);
  const duration = moment.duration(date.diff());

  if (new Date() > new Date(date)) {
    return {
      statusText: "Overdue Reminder",
      statusBar: "red",
      iconColor: "red",
      textColor: "#db2828",
      highlightColor: "#fce6e6",
    };
  }

  if (
    duration.years() === 0 &&
    duration.months() === 0 &&
    duration.days() === 0 &&
    duration.hours() <= 12 &&
    duration > 0
  ) {
    return {
      statusText: "Upcoming Reminder",
      statusBar: "yellow",
      iconColor: "yellow",
      textColor: "#fbbd08",
      highlightColor: "#fdf7e4",
    };
  }

  return {
    statusText: "In Progress",
    statusBar: "green",
    iconColor: "grey",
    textColor: "grey",
    highlightColor: "rgba(0,0,0,0)",
  };
};

export default useReminderStatus;
